import { Theme, makeStyles } from '@material-ui/core/styles';

export const useRequestPqlStyles = (readOnly: boolean, theme: Theme) =>
  makeStyles({
    mainDiv: {
      background: theme.palette.background.paper,
      height: 'calc(100% - 65px)',
      width: '100%',
      position: 'absolute',
      zIndex: 1,
      top: 65,
      left: 0,
    },
    mobilePaper: {
      padding: 16,
      margin: 8,
      marginLeft: -16,
      display: 'flex',
      whiteSpace: 'nowrap',
      justifyContent: 'center',
      zIndex: 1,
      position: 'absolute',
      alignItems: 'center'
    },
    desktopPaper: {
      padding: 16,
      marginTop: 8,
      marginBottom: 8,
      marginLeft: -4,
      minWidth: readOnly ? 300 : 550,
      display: 'flex',
      whiteSpace: 'nowrap',
      justifyContent: 'center',
      zIndex: 1,
      position: 'absolute',
      alignItems: 'center'
    },
    button: {
      margin: 8,
      marginRight: 0,
      height: 20,
      fontSize: 10,
      whiteSpace: 'nowrap',
    },
  })();
